import React, { useRef, useState } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Path from "app/route/Path";
import SegmentedControl from "app/components/commonUI/SegmentedControl";
import ProductGrid from "app/components/Product/ProductGrid";
import ProductGridItem from "app/components/Product/ProductGridItem";
// import MainMenuItem from "app/components/MainMenuItem";
// import CommonConfirmDialog from "app/components/CommonDialog";
// import Path from "app/route/Path";

function Recommend() {
  const navigate = useNavigate();

  const correctionButtonClicked = () => {
    console.log("ButtonClicked22222");
    navigate(Path.consignmentModification);
  };
  const ButtonClicked = () => {
    console.log("ButtonClicked22222");
    // navigate(Path.consignmentModification);
  };

  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "委託先情報",
      }}
    >
      <p>委託先情報</p>

      <button onClick={correctionButtonClicked}>修正</button>
      <button onClick={ButtonClicked}>削除</button>
    </DefaultLayout>
  );
}

export default Recommend;
